<template>
  <b-sidebar
    id="sidebar-activity"
    :visible="isShowSidebar"
    aria-labelledby="sidebar-activity"
    shadow
    right
    :lazy="true"
    backdrop
    :no-enforce-focus="true"
    width="40vw"
    @hidden="hide"
  >
    <template #header>
      <b-row class="header-filter no-gutters">
        <b-col class="text-filter">Forward</b-col>
        <b-col class="text-right">
          <button class="btn-clear" @click.prevent="clearFilter">x</button>
        </b-col>
      </b-row>
    </template>
    <div class="panel-reply-body">
      <div class="p-3" v-if="item || isThreadHistory == 1">
        <template v-if="item && isThreadHistory != 1">
          <div
            class="activity-card"
            :class="[
              { private: item.ticket_activity_type_id == 1 },
              { system: item.ticket_log_type_id == 1 },
              { forward: item.ticket_action_id == 13 },
              { thread: item.ticket_action_id == 14 },
              { 'mb-3': n != threadList.length - 1 },
            ]"
            v-for="(i, n) of threadList"
            :key="'thread-reply-' + i.id"
          >
            <div class="name">
              <div>
                <div class="d-flex align-items-center column-gap-lg">
                  {{ i.name_created || "-" }}
                  <small v-if="i.ticket_action_id == 13 && i.is_reply">
                    <li>Replied</li>
                  </small>
                  <small v-else-if="i.ticket_action_id == 13 && !i.is_reply">
                    <li>Forwarded</li></small
                  >
                  <small v-if="i.ticket_action_id == 14">
                    <li>Thread</li></small
                  >
                </div>
                <span
                  v-if="
                    i.ticket_activity_type_id == 1 && i.ticket_log_type_id == 2
                  "
                  class="sub-title"
                  >added a private note</span
                >
              </div>
            </div>
            <div class="date" v-if="i.email_forward">
              FWD : {{ i.email_forward }}
            </div>
            <div class="date" v-if="i.email_cc" style="word-break: break-all">
              CC : {{ i.email_cc }}
            </div>
            <div class="date">
              {{ $moment(i.created_time).fromNow() }}
              ({{ $moment(i.created_time).format("DD/MM/YYYY HH:mm:ss") }})
              <template v-if="[7, 8, 13, 15].includes(i.ticket_action_id)">
                - Via. Email
              </template>
            </div>

            <div
              class="note mt-2 alway-open"
              v-html="replaceCharacter(i.note)"
            ></div>
            <hr />

            <template v-if="i.attach_file.length > 0">
              <div class="text-bold mt-3">File Attachment</div>
              <div
                class="action-button cursor-pointer mr-2"
                v-for="file of i.attach_file"
                :key="file"
                @click.prevent="openFile(file.path)"
              >
                <font-awesome-icon
                  icon="file"
                  title="file attachment"
                  class="mr-2"
                />
                <span class="f-12"> {{ file.fileName }}</span>
              </div>
            </template>
          </div>
        </template>
      </div>

      <ReplyForm
        class="p-3"
        :hideSubject="item ? true : false"
        :form="form"
        :setting="setting"
        @addFileAttachment="addFileAttachment"
        nameRef="createThreadBody"
        :contactForwardEmailList="contactForwardEmailList"
        :v="$v"
        ref="container-reply"
      />
    </div>
    <template #footer>
      <div
        v-if="isThreadHistory != 1"
        class="d-flex justify-content-between shadow align-items-center footer"
      >
        <div class="w-100">
          <b-button
            block
            variant="dark"
            class="text-light rounded-pill"
            @click.prevent="hide"
          >
            Cancel
          </b-button>
        </div>
        <div class="w-100">
          <b-button
            @click.prevent="submit"
            block
            variant="light"
            id="handle-search-filter"
            class="text-body rounded-pill btn-main"
          >
            Send
          </b-button>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ReplyForm from "@/components/ticket/activity/ReplyForm.vue";
import { requiredIf } from "vuelidate/lib/validators";
import TicketMixins from "@/mixins/ticket";

export default {
  mixins: [TicketMixins],
  components: {
    ReplyForm,
  },
  props: {
    setting: {
      type: Object,
      required: true,
    },
    ticketDetail: {
      type: Object,
      required: true,
    },
    userProfile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isShowSidebar: false,
      filter: {
        status: [],
      },
      fileAttach: [],
      form: {
        target_email: [],
        subject: "",
        body: "",
        messageId: "",
        ticket_id: this.$route.params.ticketId,
        user_guid: "", // admin user guid
        ticket_activity_id: 0,
        cc_email: [],
        is_forward: true,
        is_forward_only: false,
      },
      isReply: false,
      title: "",
      item: null,
      isThreadHistory: 0,
      threadHistory: [],
      threadList: [],
      isShow: false,
      activeIndex: 0,
      isLoading: false,
    };
  },

  computed: {},
  validations() {
    return {
      form: {
        body: { required },
        target_email: { required },
        subject: {
          required: requiredIf(function (item, val) {
            return item.ticket_activity_id == 0 || !item.ticket_activity_id;
          }),
        },
      },
    };
  },
  created() {},
  methods: {
    async show(card) {
      this.isThreadHistory = card;

      this.isReply = true;
      this.item = card;
      this.form = {
        target_email: [],
        subject: card.name,
        body: await this.buildForwardBody(card),
        messageId: "",
        ticket_id: this.$route.params.ticketId,
        user_guid: "", // admin user guid
        ticket_activity_id: card.id,
        cc_email: [],
        is_forward: true,
        is_forward_only: false,
        ticket_email_plugin_id: this.ticketDetail.ticket_email_plugin_id,
        ticket_email_plugin: [this.ticketDetail.ticket_email_plugin],
      };
      this.getForwardDetail();

      this.title = "Reply Forward";

      this.isShowSidebar = true;

      // this.form.body = this.form.body + newSignature;
      await this.$nextTick();
      if (card.attach_file.length > 0)
        this.$bus.$emit(
          "addEditorFile",
          ...card.attach_file.map((el) => ({
            name: el.fileName,
            path: el.path,
          }))
        );
    },
    hide() {
      this.isShowSidebar = false;
      this.form = {
        target_email: [],
        subject: "",
        body: "",
        ticket_id: this.$route.params.ticketId,
        cc_email: [],
        attach_file: [],
      };
    },
    clearFilter() {
      this.hide();
    },
    addFileAttachment(list) {
      this.fileAttach = list;
    },
    async submit() {
      if (this.isReply) this.onReplyEmail();
      else this.createThread();
    },

    async onReplyEmail() {
      try {
        this.$v.form.$touch();
        if (this.$v.form.$error) return;
        this.$bus.$emit("showLoading");
        let file = this.fileAttach.map((el) => {
          return { fileName: el.name, path: el.path };
        });
        let payload = {
          ...this.form,
          ticket_email_plugin: this.form.ticket_email_plugin[0] || "",
          body: this.$refs["container-reply"].normalizeQuotes(),
          target_email: this.form.target_email.join(","),
          cc_email: this.form.cc_email.join(","),

          attach_file: file.length == 0 ? null : file,
        };
        const { data } = await this.axios.post(`/ticket/replymail`, payload);
        this.$bus.$emit("hideLoading");
        if (data.result == 1) {
          this.successAlert().then(() => {
            this.fileAttach = [];
            this.isShowSidebar = false;
            this.$emit("action");
          });
        } else {
          this.errorAlert(data.message);
        }
      } catch (error) {
        this.errorAlert(error.message);
      }
    },
    replaceCharacter(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    getTitle() {
      return "Forward";
    },

    async getForwardDetail() {
      this.isLoading = true;
      const payload = {
        ticket_id: this.$route.params.ticketId,
        is_show_all_activity: 0,
        page: 1,
        take: 999999,
        pageSize: 99999,
        forward_id: this.item.id,
      };

      const { data } = await this.axios.post(
        `/ticket/activity/detail`,
        payload
      );
      if (data.result == 1) {
        this.threadList = [this.item, ...data.detail.data];

        this.rows = data.detail.total;
      }
      this.isLoading = false;
    },
    async showEditor(card, isForward, n) {
      this.isLoading = true;
      if (!isForward) {
        this.form.previos_message_body = await this.buildReplyBody(card);

        this.form.target_email = card.email.split(",");
      } else {
        this.form.previos_message_body = await this.buildForwardBody(card);
        this.form.target_email = [];
      }
      this.isLoading = false;
      this.form.is_forward = isForward;
      this.form.ticket_activity_id = card.id;
      this.activeIndex = n;
      this.isShow = true;
    },
    openFile(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .b-sidebar > .b-sidebar-header {
  font-size: 16px;
  display: block;
  padding: unset;
}
.header-filter {
  background-color: var(--theme-secondary-color);
  padding: 15px 0.5rem;
}
.text-filter {
  font-weight: 600;
}

.text-filter {
  font-weight: 600;
}
.btn-clear {
  background-color: transparent;
  border: none;
}
::v-deep .input-group-text {
  background-color: #fff;
  padding: 0 0.75rem;
}

::v-deep .btn-main,
.btn-mains button {
  background-color: var(--primary-color) !important;
  border: 1px solid var(--primary-color);
}

.footer {
  ::v-deep .rounded-pill {
    border-radius: 0px !important;
  }
  ::v-deep .btn-main,
  .btn-mains button {
    width: 100% !important;
  }
}

.text-under {
  text-decoration: underline;
}

input.search-bar::placeholder {
  text-transform: capitalize;
}
.form-group {
  margin-bottom: 0.5rem !important;
}

.dependent-form {
  background-color: var(--secondary-color);
  padding: 16px;
}

.question-card-title {
  display: flex;
  gap: 4px;
  align-items: center;
}

.type-box {
  padding: 2px 8px;
  color: var(--primary-color);
  background-color: var(--secondary-color);
  border-radius: 6px;
}

.text-light-grey {
  color: #9a9a9a;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .pagination-action {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}

.w-100px {
  width: 101px !important;
  min-width: 0 !important;
}
.name {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: black;
  .sub-title {
    font-size: 12px;
    font-weight: normal;
  }

  .icon {
    color: var(--primary-color);
    cursor: pointer;
    font-size: 16px;
  }
}
.thread {
  background-color: #b6c7ffc2;
  border-color: #dadada;
  padding: 8px;
  border: 1px solid #dadada;
  border-radius: 10px;
  cursor: pointer;
}
.thread-detail.thread:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15) !important;
}
.date {
  font-size: 12px;
  color: #bababa;
}
.note {
  ::v-deep p {
    margin: 0;
    img {
      max-width: 100%;
      max-height: max-content;
    }
  }
}
.activity-card {
  display: flex;
  gap: 2px;
  flex-direction: column;
  padding: 8px;
  border: 1px solid #dadada;
  border-radius: 10px;
  background-color: white;

  &.private {
    background-color: var(--primary-color-light);
    border-color: var(--theme-secondary-color);
  }

  &.system {
    background-color: whitesmoke;
    border-color: #dadada;
  }
  &.forward {
    background-color: #d9ebff;
    border-color: #dadada;
  }
  &.thread {
    background-color: #b6c7ffc2;
    border-color: #dadada;
  }
  ::v-deep img {
    max-width: 100%;
  }
}
.note.alway-open {
  // display: block;
  max-height: calc(25vh - 91px);
  overflow: auto;
}
.panel-reply-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 91px);
}
</style>
